import { PurchaseOrder } from '../../interfaces/purchase-order.interface';

export function createEmptyPurchaseOrder(): PurchaseOrder {
  return {
    PurchaseOrderID: null,
    PurchaseDate: new Date(),
    Intermediary: '',
    IntermediaryNumber: undefined,
    MarineInsurance: null,
    CustomsEntry: null,
    FreightCharge: null,
    Drayage: null,
    MiscInboundCharge: null,
    InboundTariff: null,
    LandedCost: undefined,
    Inventory: [],
    SupplierID: 0,
    SupplierAgent: '',
    TraderGUID: undefined,
    ConnectedPurchaseOrderID: undefined,
    TariffInPrice: false,
    Connected: false,
    PurchaseOrderSpread: '',
  };
}

export function toPurchaseOrder(obj: any): PurchaseOrder {
  return {
    PurchaseOrderID: obj.PurchaseOrderID,
    PurchaseDate: obj.PurchaseDate,
    Intermediary: obj.Intermediary,
    IntermediaryNumber: obj.IntermediaryNumber,
    Inventory: obj.Inventory,
    SupplierID: obj.SupplierID,
    SupplierAgent: obj.SupplierAgent,
    TraderGUID: obj.TraderGUID,
    ConnectedPurchaseOrderID: obj.ConnectedPurchaseOrderID,
    TariffInPrice: obj.TariffInPrice,
    Connected: obj.Connected,
    PurchaseOrderSpread: obj.PurchaseOrderSpread,
    MarineInsurance: obj.MarineInsurance ?? null,
    CustomsEntry: obj.CustomsEntry ?? null,
    FreightCharge: obj.FreightCharge ?? null,
    Drayage: obj.Drayage ?? null,
    MiscInboundCharge: obj.MiscInboundCharge ?? null,
    InboundTariff: obj.InboundTariff ?? null,
    LandedCost: obj.LandedCost,
  };
}
